import { NAB_PORTFOLIO_PIDS_URL } from "../config/deforestation";

// JSON file is keyed by demo cluster name → cadastrePid[]. We only need
// the flat set of pids at runtime, the cluster grouping isn't surfaced
// in the UI.
type PortfolioJson = Record<string, string[]>;

let pids: string[] | null = null;
let pidsPromise: Promise<string[]> | null = null;

export function ensureNabPortfolioPids(): Promise<string[]> {
  if (pids) return Promise.resolve(pids);
  if (pidsPromise) return pidsPromise;
  pidsPromise = fetch(NAB_PORTFOLIO_PIDS_URL)
    .then((res) => {
      if (!res.ok) {
        throw new Error(
          `nab-portfolio-pids fetch failed: ${res.status} ${res.statusText}`,
        );
      }
      return res.json() as Promise<PortfolioJson>;
    })
    .then((data) => {
      const flat = Array.from(new Set(Object.values(data).flat()));
      pids = flat;
      return flat;
    })
    .catch((err) => {
      console.error("[nab-deforestation] portfolio pids load failed:", err);
      pids = [];
      return [] as string[];
    });
  return pidsPromise;
}

export function getNabPortfolioPids(): string[] {
  return pids ?? [];
}
